import { Component, inject, model, OnInit, output, ChangeDetectionStrategy } from '@angular/core';
import { CarritoCompraService } from '@shared/services/carrito-compra.service';
import { CarritoCompraProducto } from '../carrito-compra-producto/carrito-compra-producto';
import { CurrencyPipe } from '@angular/common';
import { IProductoCarritoData } from '@core/interfaces/entidades/productoCarrito.entidad';
import { UiButton, UiDialog, UiTooltip } from '@shared/components/ui';
import { ProcesarVenta } from '../procesar-venta/procesar-venta';
import { AgregarProductoLibre } from '../agregar-producto-libre/agregar-producto-libre';
import { IProductoLibre } from '@core/interfaces/producto.libre.interface';

@Component({
  selector: 'app-carrito-compra',
  imports: [
    CurrencyPipe,
    CarritoCompraProducto,
    UiDialog,
    ProcesarVenta,
    UiButton,
    UiTooltip,

    AgregarProductoLibre,
  ],
  templateUrl: './carrito-compra.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './carrito-compra.css',
})
export class CarritoCompra implements OnInit {
  private carritoCompraService = inject(CarritoCompraService);
  carritoCompraProductos?: IProductoCarritoData[];

  ngOnInit(): void {
    this.carritoCompraService.productosCarritoCompra.subscribe((productos) => {
      this.carritoCompraProductos = productos;
    });
  }
  calcularTotal(): number {
    let total = 0;
    if (!this.carritoCompraProductos) {
      return total;
    }
    this.carritoCompraProductos.forEach((producto) => {
      total += producto.precio * producto.cantidad;
    });
    return total;
  }

  total(): number {
    // Aquí puedes agregar lógica para calcular el total con impuestos, descuentos, etc.
    return this.calcularTotal();
  }

  modal_procesar_venta = model<boolean>(false);
  modal_producto_libre = model<boolean>(false);

  procesarPago() {
    if (!this.carritoCompraProductos || this.carritoCompraProductos.length === 0) {
      return;
    }
    this.modal_procesar_venta.set(true);
  }
  vaciarCarrito() {
    this.carritoCompraService.limpiar();
  }

  emitirVenta = output<void>();
  onEmitirVenta() {
    this.emitirVenta.emit();
  }

  onAgregarProducto(producto: IProductoLibre) {
    this.carritoCompraService.agregarProductoLibre(producto);
    this.modal_producto_libre.set(false);
  }
}
